
<div
	class="flow-wrapper"
	:data-type="type"
	:style="style"
	:data-border="border"
	:data-background="background"
	:data-overflow="overflow"
>
	<slot />
</div>
